import React, { useMemo, useState, useEffect } from "react";
import Select from "react-select";

const RequestTeamEditForm = () => {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));

  const [formData, setFormData] = useState({
    profile_details: "",
    vertical: "",
    priority: "",
    location: "",
    skills: "",
    exp_min: "",
    exp_max: "",
    budget_month: "",
    budget_annum: "",
    position_open_date: "",
    hiring_type: "",
    replacement_for: "",
    working_mode: "",
    remarks: "",
  });
  const [status, setStatus] = useState("Open");
  const [loading, setLoading] = useState(false);
  const [depdata, setDepdata] = useState([]);
  const [skillData, setSkillData] = useState([]);

  const [selectedVertical, setSelectedVertical] = useState(null);
  const [selectedSkills, setSelectedSkills] = useState([]);

  const [loadingVertical, setLoadingVertical] = useState(false);
  const [loadingSkills, setLoadingSkills] = useState(false);

  // =========================================================
  // Get Vertical List
  // =========================================================

  useEffect(() => {
    getDepartmentList();
  }, []);

  const getDepartmentList = async () => {
    try {
      setLoadingVertical(true);

      const response = await fetch(
        SERVER_URL + "api/common/department_group_list",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `bearer ${token?.value}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      setDepdata(data?.result || []);
    } catch (error) {
      console.error("Error fetching vertical list:", error);
    } finally {
      setLoadingVertical(false);
    }
  };

  // =========================================================
  // Vertical Options
  // =========================================================

  const Vertical_option = useMemo(() => {
    return (
      depdata?.map((row) => ({
        group_id: row.group_id,
        value: row.id,
        label: row.name,
      })) || []
    );
  }, [depdata]);

  // =========================================================
  // Skill Options Based On Selected Vertical
  // =========================================================

  const Skill_options = useMemo(() => {
    if (!selectedVertical) {
      return [];
    }

    return (
      skillData
        ?.filter(
          (skill) =>
            Number(skill.group_id) === Number(selectedVertical?.group_id),
        )
        .map((skill) => ({
          value: skill.id,
          label: skill.name,
        })) || []
    );
  }, [skillData]);
  // console.log(skillData, "skillData=========");
  // console.log(selectedVertical, "selectedVertical=========");
  // =========================================================
  // Vertical Change
  // =========================================================

  const handleVerticalChange = async (selectedOption) => {
    console.log("Selected Vertical:", selectedOption);

    // Set selected vertical
    setSelectedVertical(selectedOption);

    // Clear previous skills
    setSelectedSkills([]);
    setSkillData([]);

    // Update formData
    setFormData((prev) => ({
      ...prev,
      vertical: selectedOption?.value || "",
      skills: [],
    }));

    if (!selectedOption) {
      return;
    }

    const verticalId = selectedOption.group_id;

    console.log("Sending Vertical ID:", verticalId);

    try {
      setLoadingSkills(true);

      const response = await fetch(
        SERVER_URL + `api/common/getSkillGroupList?vertical_id=${verticalId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `bearer ${token.value}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      console.log("Skill API Response:", data);
      console.log("Skill API Result:", data?.data);

      setSkillData(data?.data || []);
    } catch (error) {
      console.error("Skill error:", error);
      setSkillData([]);
    } finally {
      setLoadingSkills(false);
    }
  };
  // =========================================================
  // Skill Change
  // =========================================================

  const handleSkillChange = (selectedOptions) => {
    const skills = selectedOptions || [];

    console.log("Selected Skills:", skills);

    // Update Select value
    setSelectedSkills(skills);

    // Update formData
    setFormData((prev) => ({
      ...prev,
      skills: skills.map((skill) => skill.value),
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Automatically calculate annual budget
    if (name === "budget_month") {
      const monthly = Number(value || 0);

      setFormData((prev) => ({
        ...prev,
        budget_month: value,
        budget_annum: monthly * 12,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      console.log(formData, "formData==============");
      const response = await fetch(SERVER_URL + `api/requestTeam/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Something went wrong while saving the request",
        );
      }

      alert(data.message || "Request created successfully");
      // Reset form
      setFormData({
        profile_details: "",
        vertical: "",
        priority: "",
        location: "",
        skills: [],
        exp_min: "",
        exp_max: "",
        budget_month: "",
        budget_annum: "",
        position_open_date: "",
        hiring_type: "",
        replacement_for: "",
        working_mode: "",
        remarks: "",
      });
    } catch (error) {
      console.error(error);
      alert(
        error.response?.data?.message ||
          "Something went wrong while saving the request",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="card shadow-sm border-0">
        {/* Header */}
        <div className="card-header bg-white border-bottom">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">Request Team</h4>
              <p className="text-muted mb-0">Define the hiring requirement</p>
            </div>

            <span className="badge bg-success px-3 py-2">Status: {status}</span>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card-body">
            {/* Profile Details */}
            <div className="section-title">
              <h5>Profile Details</h5>
            </div>

            <div className="row g-3">
              <div className="col-md-12">
                <label className="form-label">
                  Profile Details <span className="text-danger">*</span>
                </label>

                <textarea
                  className="form-control"
                  name="profile_details"
                  rows="3"
                  placeholder="Enter profile / job requirement details"
                  value={formData.profile_details}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Vertical */}
              <div className="col-md-4">
                <label className="form-label">
                  Vertical <span className="text-danger">*</span>
                </label>
                <Select
                  name="vertical"
                  options={Vertical_option}
                  value={selectedVertical}
                  onChange={handleVerticalChange}
                  placeholder="Select Vertical"
                  isSearchable
                  isClearable
                  isLoading={loadingVertical}
                />
                {/* <Select
                  onChange={(e) => {
                    setDepdata(e.value);
                  }}
                  options={Vertical_option}
                /> */}
                {/* <select
                  className="form-select"
                  name="vertical"
                  value={formData.vertical}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Vertical</option>
                  {depdata?.map((item, ind) => (
                    <option key={ind} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select> */}
              </div>

              {/* Priority */}
              <div className="col-md-4">
                <label className="form-label">
                  Priority <span className="text-danger">*</span>
                </label>

                <select
                  className="form-select"
                  name="priority"
                  value={formData.priority}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Priority</option>
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Critical">Critical</option>
                </select>
              </div>

              {/* Location */}
              <div className="col-md-4">
                <label className="form-label">
                  Location <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="location"
                  placeholder="e.g. Noida"
                  value={formData.location}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Skills */}
              <div className="col-md-6">
                <label className="form-label">
                  Skills <span className="text-danger">*</span>
                </label>

                <Select
                  name="skills"
                  options={Skill_options}
                  value={selectedSkills}
                  onChange={handleSkillChange}
                  placeholder={
                    selectedVertical
                      ? "Search and select skills..."
                      : "First select vertical"
                  }
                  isMulti
                  isSearchable
                  isClearable
                  isDisabled={!selectedVertical}
                  isLoading={loadingSkills}
                  closeMenuOnSelect={false}
                  noOptionsMessage={() =>
                    selectedVertical
                      ? "No skills available"
                      : "Select vertical first"
                  }
                />

                <small className="text-muted">
                  Separate multiple skills using comma
                </small>
              </div>

              {/* Experience */}
              <div className="col-md-6">
                <label className="form-label">Experience Range (Years)</label>

                <div className="row">
                  <div className="col-6">
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      name="exp_min"
                      placeholder="Min"
                      value={formData.exp_min}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-6">
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      name="exp_max"
                      placeholder="Max"
                      value={formData.exp_max}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              {/* Budget */}
              <div className="col-md-6">
                <label className="form-label">Budget / Month</label>

                <div className="input-group">
                  <span className="input-group-text">₹</span>

                  <input
                    type="number"
                    min="0"
                    className="form-control"
                    name="budget_month"
                    placeholder="Monthly budget"
                    value={formData.budget_month}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Annual Budget */}
              <div className="col-md-6">
                <label className="form-label">Budget / Annum</label>

                <div className="input-group">
                  <span className="input-group-text">₹</span>

                  <input
                    type="number"
                    className="form-control bg-light"
                    name="budget_annum"
                    value={formData.budget_annum}
                    readOnly
                  />
                </div>

                <small className="text-muted">
                  Automatically calculated as Monthly Budget × 12
                </small>
              </div>

              {/* Position Open Date */}
              <div className="col-md-4">
                <label className="form-label">
                  Position Open Date <span className="text-danger">*</span>
                </label>

                <input
                  type="date"
                  className="form-control"
                  name="position_open_date"
                  value={formData.position_open_date}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Hiring Type */}
              <div className="col-md-4">
                <label className="form-label">
                  Hiring Type <span className="text-danger">*</span>
                </label>

                <select
                  className="form-select"
                  name="hiring_type"
                  value={formData.hiring_type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Hiring Type</option>
                  <option value="New Position">New Position</option>
                  <option value="Replacement">Replacement</option>
                  <option value="Contract">Contract</option>
                  <option value="Intern">Intern</option>
                </select>
              </div>

              {/* Replacement */}
              <div className="col-md-4">
                <label className="form-label">Replacement For</label>

                <input
                  type="text"
                  className="form-control"
                  name="replacement_for"
                  placeholder="Employee name / ID"
                  value={formData.replacement_for}
                  onChange={handleChange}
                />
              </div>

              {/* Working Mode */}
              <div className="col-md-6">
                <label className="form-label">
                  Working Mode <span className="text-danger">*</span>
                </label>

                <div className="d-flex gap-4 mt-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="working_mode"
                      value="Work From Office"
                      checked={formData.working_mode === "Work From Office"}
                      onChange={handleChange}
                    />

                    <label className="form-check-label">Work From Office</label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="working_mode"
                      value="Hybrid"
                      checked={formData.working_mode === "Hybrid"}
                      onChange={handleChange}
                    />

                    <label className="form-check-label">Hybrid</label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="working_mode"
                      value="Remote"
                      checked={formData.working_mode === "Remote"}
                      onChange={handleChange}
                    />

                    <label className="form-check-label">Remote</label>
                  </div>
                </div>
              </div>

              {/* Status */}
              <div className="col-md-6">
                <label className="form-label">Status</label>

                <input
                  type="text"
                  className="form-control bg-light"
                  value={status}
                  readOnly
                  disabled
                />

                <small className="text-muted">
                  Status is automatically linked from Hiring Team.
                </small>
              </div>

              {/* Remarks */}
              <div className="col-md-12">
                <label className="form-label">Remarks</label>

                <textarea
                  className="form-control"
                  name="remarks"
                  rows="3"
                  placeholder="Enter any additional remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="card-footer bg-white d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-light border"
              onClick={() => window.history.back()}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn btn-primary px-4"
              disabled={loading}
            >
              {loading ? "Saving..." : "Create Request"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequestTeamEditForm;
